import React from "react";
import { Box, Tooltip } from "@mui/material";
import { tokens } from "../../theme";
import { IconMonitor, IconMoon, IconSun } from "../ui/icons";
import { useColorScheme } from "../../hooks/useColorScheme";

const OPTIONS = [
  { id: "light", label: "Claro", icon: IconSun },
  { id: "dark", label: "Oscuro", icon: IconMoon },
  { id: "system", label: "Sistema", icon: IconMonitor },
];

/**
 * Selector de tema del menú lateral: claro, oscuro o seguir al sistema.
 * Colapsado, rota entre las tres opciones con un toque.
 */
const ThemeSwitch = ({ collapsed = false }) => {
  const { scheme, setScheme } = useColorScheme();
  const current = OPTIONS.find((option) => option.id === scheme) || OPTIONS[2];
  const CurrentIcon = current.icon;

  if (collapsed) {
    const next = OPTIONS[(OPTIONS.indexOf(current) + 1) % OPTIONS.length];
    return (
      <Tooltip title={`Tema: ${current.label} · tocá para pasar a ${next.label}`} placement="right" arrow>
        <Box
          role="button"
          aria-label={`Cambiar tema. Actual: ${current.label}`}
          onClick={() => setScheme(next.id)}
          sx={{
            width: 38,
            height: 38,
            margin: "0 auto 8px",
            borderRadius: "8px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            color: tokens.graphiteInk2,
            cursor: "pointer",
            "&:hover": { backgroundColor: tokens.graphite3, color: tokens.graphiteInk },
          }}
        >
          <CurrentIcon size={17} />
        </Box>
      </Tooltip>
    );
  }

  return (
    <Box
      role="radiogroup"
      aria-label="Tema de la interfaz"
      sx={{
        display: "grid",
        gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
        gap: "2px",
        padding: "3px",
        borderRadius: "9px",
        backgroundColor: tokens.graphite3,
        marginBottom: "10px",
      }}
    >
      {OPTIONS.map((option) => {
        const Icon = option.icon;
        const active = option.id === scheme;
        return (
          <Tooltip key={option.id} title={option.label} placement="top" arrow>
            <Box
              role="radio"
              aria-checked={active}
              aria-label={option.label}
              onClick={() => setScheme(option.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                gap: "5px",
                minHeight: 30,
                borderRadius: "7px",
                cursor: "pointer",
                fontSize: "11.5px",
                fontWeight: active ? 500 : 400,
                color: active ? "#ffffff" : tokens.graphiteInk3,
                backgroundColor: active ? tokens.graphite2 : "transparent",
                "&:hover": { color: tokens.graphiteInk },
              }}
            >
              <Icon size={14} />
            </Box>
          </Tooltip>
        );
      })}
    </Box>
  );
};

export default ThemeSwitch;
